import BuyerRouter from './Buyer.router';
export default BuyerRouter;

export { default as buyerRouterRoutes } from './routes';
